import { Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { checkLoggedIn } from '../helpers/user';

const ProtectedRoute = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null);

    useEffect(() => {
        const verifyAuth = async () => {
            const status = await checkLoggedIn();
            setIsAuthenticated(status);
        };
        verifyAuth();
    }, []);

    // Show loading state while checking authentication
    if (isAuthenticated === null) {
        return <div>Chargement...</div>; // You might want to use a proper loading component
    }

    // Redirect to login if not authenticated
    if (!isAuthenticated) {
        return <Navigate to="/connexion" replace />;
    }

    // Render children if authenticated
    return children;
};

export default ProtectedRoute;